import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let AgencyService = class AgencyService {
    constructor(MarketplaceApi) {
        this.MarketplaceApi = MarketplaceApi;
    }
    getAgencyList(params) {
        return this.MarketplaceApi.getAgencyList(params.page, params.limit);
    }
    getAgency(id) {
        return this.MarketplaceApi.getAgency(id);
    }
    logoUpload(base64) {
        return this.MarketplaceApi.logoUpload(base64);
    }
    updateAgency(agency_id, FormData) {
        return this.MarketplaceApi.updateAgency(agency_id, FormData);
    }
    createAgency(FormData) {
        return this.MarketplaceApi.createAgency(FormData);
    }
    getAgentList(id) {
        return this.MarketplaceApi.getAgentList(id);
    }
    addAgentToAgency(user_name, agency_id) {
        return this.MarketplaceApi.addAgentToAgency(user_name, agency_id);
    }
    removeAgent(agent_id) {
        return this.MarketplaceApi.removeAgent(agent_id);
    }
    /** 代理所 访问记录 */
    async getAgentAccessList(params) {
        const res = await this.MarketplaceApi.getAgentAccessList(params);
        if (res && res.status) {
            return res.data;
        }
        return {
            agency_info_list: [],
            sum_count: 0,
        };
    }
    getAgentAccessExport(params) {
        return this.MarketplaceApi.getAgentAccessExport(params);
    }
    /** 代理所 购买记录 */
    async getAgentBuyList(params) {
        const res = await this.MarketplaceApi.getAgentBuyList(params);
        if (res && res.status) {
            return res.data;
        }
        return {
            agency_info_list: [],
            sum_count: 0,
        };
    }
    getAgentBuyExport(params) {
        return this.MarketplaceApi.getAgentBuyExport(params);
    }
    /** 代理所 订阅记录 */
    async getAgentSubscribeList(params) {
        const res = await this.MarketplaceApi.getAgentSubscribeList(params);
        if (res && res.status) {
            return res.data;
        }
        return {
            agency_info_list: [],
            sum_count: 0,
        };
    }
    getAgentSubscribeExport(params) {
        return this.MarketplaceApi.getAgentSubscribeExport(params);
    }
    /** 导航库 购买记录 */
    async getNavigationBuyList(params) {
        const res = await this.MarketplaceApi.getNavigationBuyList(params);
        if (res && res.status) {
            return res.data;
        }
        return {
            agency_info_list: [],
            sum_count: 0,
        };
    }
    getNavigationBuyExport(params) {
        return this.MarketplaceApi.getNavigationBuyExport(params);
    }
    /** 导航库 订阅记录 */
    async getNavigationSubscribeList(params) {
        const res = await this.MarketplaceApi.getNavigationSubscribeList(params);
        if (res && res.status) {
            return res.data;
        }
        return {
            agency_info_list: [],
            sum_count: 0,
        };
    }
    getNavigationSubscribeExport(params) {
        return this.MarketplaceApi.getNavigationSubscribeExport(params);
    }
};
AgencyService = __decorate([
    injectable(),
    __param(0, inject(Symbols.MarketplaceApi)),
    __metadata("design:paramtypes", [Object])
], AgencyService);
export { AgencyService };
